/**
 * Browser entry point for DynamicForms React.
 *
 * Multiple DNN module instances can exist on one page. Each root is mounted once,
 * receives its own runtime configuration, and is scoped with df-bs-3/df-bs-5 so
 * Bootstrap compatibility rules never leak into the surrounding skin.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { getRuntimeConfig, normalizeBootstrapVersion } from './app/runtime-config';
import './styles/app.css';

const DYNAMICFORMS_RUNTIME_REVISION = '2.6.0.20';
const PERSIAN_CAPTCHA_REVISION = '1.0.0';

const rootElements = Array.from(document.querySelectorAll<HTMLElement>('[data-dynamicforms-react-root]'));
if (!rootElements.length) throw new Error('DynamicForms React root element was not found.');

for (const rootElement of rootElements) {
  if (rootElement.dataset.reactMounted === '1') continue;
  rootElement.dataset.reactMounted = '1';
  rootElement.dataset.dfRuntimeRevision = DYNAMICFORMS_RUNTIME_REVISION;
  rootElement.dataset.dfPersianCaptchaRevision = PERSIAN_CAPTCHA_REVISION;
  const config = getRuntimeConfig(rootElement);
  const bootstrapVersion = normalizeBootstrapVersion(config.bootstrapVersion);
  config.bootstrapVersion = bootstrapVersion;
  rootElement.dataset.bootstrapVersion = bootstrapVersion;
  rootElement.classList.remove('df-bs-3', 'df-bs-5');
  rootElement.classList.add(`df-bs-${bootstrapVersion}`);
  createRoot(rootElement).render(<StrictMode><App config={config} /></StrictMode>);
}
